import  * as React from 'react'
// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';
//const: muss definiert werden unter "export default"
const WpcLigno  = () => {
    const {t} = useI18next();
    return (
        <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
          <div className='row'>

            <div className='col-12'>
              <div className='container'>
                <BoxInfo description={t('text')} />
              </div>
            </div>
          </div>
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
                {/* Übersicht */}   
                <h1 align="left"> {t('title1')} </h1>
                <p> {t('text11')} </p>
                <p> {t('text12')} </p>

                {/* Forligno */}

                <h1 align="left"> {t('title2')} </h1>
                {/* PPH 20921 */}
                <h2 align="left"> {t('subtitle21')} </h2>
                <p> {t('text211')} </p>
                <p> {t('text212')} </p>
                {/* PPH 20921 Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: &ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&ensp;&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t3')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&ensp;&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert21')}</td>
                    <td>{t('tabw1t3-wert21')}</td>
                    <td>{t('tabw1t4-wert21')}</td>
                    <td>{t('tabw1t5-wert21')}</td>
                    <td>{t('tabw1t10-wert21')}</td>
                  </tr>
                </table></div>
                </div>
                {/* PPH 20921 G05 */}
                <h2 align="left"> {t('subtitle22')} </h2>
                <p> {t('text221')} </p>
                <p> {t('text223')} </p>
                {/* Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: &ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&ensp;&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t3')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&ensp;&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert22')}</td>
                    <td>{t('tabw1t3-wert22')}</td>
                    <td>{t('tabw1t4-wert22')}</td>
                    <td>{t('tabw1t5-wert22')}</td>
                    <td>{t('tabw1t10-wert22')}</td>
                  </tr>
                </table></div>
                </div>

                {/* 30921 */}
                <h2 align="left"> {t('subtitle23')} </h2>
                <p> {t('text231')} </p>
            
                <p> {t('text233')} </p>
               {/* Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: &ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&ensp;&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t3')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&ensp;&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert23')}</td>
                    <td>{t('tabw1t3-wert23')}</td>
                    <td>{t('tabw1t4-wert23')}</td>
                    <td>{t('tabw1t5-wert23')}</td>
                    <td>{t('tabw1t10-wert23')}</td>
                  </tr>
                </table></div>
                </div>


                {/* PPH 35051 */}
                <h2 align="left"> {t('subtitle31')} </h2>
                <p> {t('text311')} </p>

                <p> {t('text313')} </p>
                {/* Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: &ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&ensp;&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t3')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&ensp;&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert23')}</td>
                    <td>{t('tabw1t3-wert23')}</td>
                    <td>{t('tabw1t4-wert23')}</td>
                    <td>{t('tabw1t5-wert23')}</td>
                    <td>{t('tabw1t10-wert23')}</td>
                  </tr>
                </table></div>
                </div>
  {/* weitere Typen */} 
                <h1 align="left"> {t('title10')} </h1>
                <p> {t('text101')} </p>  


                {/*<p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bil d" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>

    );
};

export default WpcLigno

// Fuer Search engine  optimizationjj
export const Head = () =>( <Seo title="Produktentwicklung" keywords="Produktentwicklung Biopolymere" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
export const query = graphql`
query ($language: String!) {
  locales: allLocale(
    filter: { ns: { in: ["wpcforligno"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;